module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("j6xp0"))).then(() => module.bundle.root('ljYL6'));